<template>
  <div>
    <b-modal
      id="ModalCreateResultForm"
      ref="ModalCreateResultForm"
      size="xl"
      scrollable
      hide-header
      :ok-title="$t('lbl_create')"
      :cancel-title="$t('lbl_cancel')"
      :busy="loading"
      @show="handleGetDraft"
      @ok="handleSubmitResultForm"
      @hide="handleSaveDraft"
    >
      <b-overlay :show="loading" variant="light" :opacity="0.75" blur="2px">
        <div class="cs-container">
          <span class="cs-header">{{ $t("lbl_test_result_form") }}</span>
          <div>
            <!-- <div class="cs-title">Thông tin bệnh nhân</div> -->

            <div class="d-flex py-1">
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_full_name") }}</strong>
                </span>
                <b-form-input class="cs-flex-1" v-model="form.name" placeholder="Nhập họ và tên" />
              </div>

              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_year_of_birth") }}</strong>
                </span>
                <b-form-input
                  class="cs-flex-1"
                  v-model="form.birthYear"
                  :placeholder="$t('lbl_enter_your_year_of_birth')"
                />
              </div>
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_gender") }}</strong>
                </span>
                <div class="d-flex align-items-center" style="margin-top:5px">
                  <b-form-radio class="mr-1" v-model="form.gender" name="some-radios" :value="1">{{ $t("lbl_male") }}</b-form-radio>
                  <b-form-radio v-model="form.gender" name="some-radios" :value="2">{{ $t("lbl_female") }}</b-form-radio>
                </div>
              </div>
            </div>
            <div class="d-flex py-1">
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_diagnosis") }}</strong>
                </span>
                <b-form-input
                  class="cs-flex-1 cs"
                  v-model="form.diagnosis"
                  :placeholder="$t('lbl_enter_the_diagnosis')"
                />
              </div>
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_sample") }}</strong>
                </span>
                <b-form-input class="cs-flex-1" v-model="form.sample" :placeholder="$t('lbl_enter_sample_info')" />
              </div>
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_attending_doctor") }}</strong>
                </span>
                <b-form-input
                  class="cs-flex-1"
                  v-model="form.doctorAppointed"
                  :placeholder="$t('lbl_enter_the_attending_doctor')"
                />
              </div>
            </div>
            <div class="d-flex py-1">
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_receiving_date") }}</strong>
                </span>
                <b-form-datepicker
                  :locale="$i18n.locale"
                  v-bind="$getCalendarLabel($i18n.locale)"
                  :placeholder="$t('lbl_select_receiving_date')"
                  v-model="form.date"
                ></b-form-datepicker>
              </div>
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_collection_location") }}</strong>
                </span>
                <b-form-input
                  class="cs-flex-1"
                  v-model="form.address"
                  :placeholder="$t('lbl_enter_collection_location')"
                />
              </div>
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_delivery_date") }}</strong>
                </span>
                <b-form-datepicker
                  :placeholder="$t('lbl_select_delivery_date')"
                  v-model="form.resultDate"
                  :locale="$i18n.locale"
                  v-bind="$getCalendarLabel($i18n.locale)"
                ></b-form-datepicker>
              </div>
            </div>
            <div class="d-flex py-1">
              <div class="row-item col-4">
                <span>
                  <strong>{{ $t("lbl_responsible_specialist") }}</strong>
                </span>
                <b-form-input
                  class="cs-flex-1"
                  v-model="form.mainDoctor"
                  :placeholder="$t('lbl_responsible_specialist')"
                />
              </div>
              <div class="col-4 align-items-center">
                <div class="mr-2">
                  <strong>LABcode</strong>
                </div>
                <b-form-input class="cs-flex-1" v-model="form.labCode" :placeholder="$t('lbl_enter_labcode')" />
              </div>
            </div>
          </div>
          <div class="d-flex p-1 row-item">
            <span>
              <strong>{{ $t("lbl_content") }}</strong>
            </span>
            <TiptapEditor
              class="hodo-table"
              :value="form.content"
              @setValue="t => form.content= t"
            />
          </div>
        </div>
      </b-overlay>

      <div class="d-none">
        <div ref="documentPrint">
          <div
            id="PhieuChamSoc"
            style="margin-right:auto;margin-left:auto;width:1000px"
            class="mx-auto hodo-print cs-w p-0"
          >
            <div class="px-8 mt-2">
              <div class="block flex items-center">
                <div class="col-3">
                  <div class="flex">
                    <img :src="logo.logoRight" style="max-width:200px" />
                  </div>
                </div>
                <div class="col-6 font-bold mb-6 p-0">
                  <div class="flex justify-center">
                    <div class="fs-17">{{ companyName }}</div>
                  </div>
                  <div class="flex justify-center">
                    <div class="fs-15 whitespace-nowrap">{{ userAddress }}</div>
                  </div>
                  <!-- <div class="flex justify-center">
                    <label
                      class="fs-15 whitespace-nowrap"
                    >VP HCM: 3658 & 186 Nguyễn Duy Dương, P2, Q.10, Tp.HCM</label>
                  </div>-->
                </div>
                <div class="col-3 d-flex justify-content-end text-right">
                  <img :src="logo.logoLeft" style="max-width:200px" />
                </div>
              </div>
              <div class="block">
                <div
                  class="font-bold flex flex-col justify-center items-center uppercase fs-24"
                >{{ $t("lbl_test_results") }}</div>
              </div>
              <div class="block mt-3 mb-2">
                <div class="w-full inline-block">
                  <div class="row">
                    <div class="fs-18 col-8 uppercase">{{ $t("lbl_patient_info") }}</div>
                    <div class="col-4 fs-18 text-right">
                      <span>LABcode</span>
                      <span class="inline-block ml-2" v-if="form.labCode">{{ form.labCode }}</span>
                      <span v-else>: ...............</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block mb-2">
                <div class="w-full inline-block">
                  <div>
                    <div class="col-4">
                      <div class="row">
                        <label
                          class="fs-18"
                          :style="form.name?'width:125px;display:inline-block':''"
                        >{{ $t("lbl_full_name") }}</label>
                        <span v-if="form.name">
                          :
                          <label class="font-bold fs-18">{{form.name}}</label>
                        </span>
                        <label
                          v-else
                          class="fs-18"
                        >: ....................................................</label>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="w-full inline-block">
                        <label
                          class="fs-18"
                          :style="form.birthYear?'width:100px;display:inline-block':''"
                        >{{ $t("lbl_year_of_birth") }}</label>
                        <span class="mb-0 ml-1" v-if="form.birthYear">
                          :
                          <label
                            class="fs-18 font-bold"
                          >{{ form.birthYear && moment(form.birthYear).format('YYYY') }}</label>
                        </span>
                        <label v-else class="fs-18">: ....................</label>
                      </div>
                    </div>
                    <div class="col-4">
                      <label
                        class="fs-18"
                        :style="form.gender?'width:100px;display:inline-block':''"
                      >{{ $t("lbl_gender") }}</label>
                      <span v-if="form.gender">
                        :
                        <label class="fs-18 font-bold">{{ form.gender === 1 ? $t("lbl_male") : $t("lbl_female") }}</label>
                      </span>
                      <label v-else class="fs-18">: ...............</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block mb-2">
                <div class="w-full inline-block">
                  <div>
                    <div class="col-4">
                      <div class="row">
                        <label
                          class="fs-18"
                          :style="form.diagnosis?'width:125px;display:inline-block':''"
                        >{{ $t("lbl_diagnosis") }}</label>
                        <span v-if="form.diagnosis">
                          :
                          <label class="font-bold fs-18">{{form.diagnosis}}</label>
                        </span>
                        <label v-else class="fs-18">: .............................................</label>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="w-full inline-block">
                        <label
                          class="fs-18"
                          :style="form.sample?'width:100px; display:inline-block':''"
                        >{{ $t("lbl_sample") }}</label>
                        <span v-if=" form.sample" class="mb-0 ml-1">
                          :
                          <label class="fs-18 font-bold">{{ form.sample }}</label>
                        </span>
                        <label v-else class="fs-18">: ...............................</label>
                      </div>
                    </div>
                    <div class="col-4">
                      <label
                        class="fs-18"
                        :style="form.doctorAppointed?'width:100px;display:inline-block':''"
                      >{{ $t('lbl_doctor_diagnoses') }}</label>
                      <span v-if="form.doctorAppointed">
                        :
                        <label class="fs-18 font-bold">{{ form.doctorAppointed }}</label>
                      </span>
                      <label v-else class="fs-18">: .............................................</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="block mb-2">
                <div class="w-full inline-block">
                  <div>
                    <div class="col-4">
                      <div class="row">
                        <label
                          class="fs-18"
                          :style="form.date?'width:125px;display:inline-block':''"
                        >{{ $t("lbl_receiving_date") }}</label>
                        <span v-if="form.date">
                          :
                          <label
                            class="uppercase font-bold fs-18"
                          >{{form.date && moment(form.date).format('DD/MM/YYYY') }}</label>
                        </span>
                        <label v-else class="fs-18">: ........./........./..............</label>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="w-full inline-block">
                        <label
                          class="fs-18"
                          :style="form.address?'width:100px;display:inline-block':''"
                        >{{ $t("lbl_collection_location") }}</label>
                        <span class="mb-0 ml-1" v-if=" form.address">
                          :
                          <label class="fs-18 font-bold">{{ form.address }}</label>
                        </span>
                        <label v-else class="fs-18">: ............................</label>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="row m-0">
                        <label
                          class="fs-18"
                          :style="form.resultDate?'width:100px; display:inline-block':''"
                        >{{ $t("lbl_delivery_date") }}</label>
                        <span v-if="form.resultDate">
                          :
                          <label
                            class="uppercase font-bold fs-18"
                          >{{form.resultDate && moment(form.resultDate).format('DD/MM/YYYY') }}</label>
                        </span>
                        <label v-else class="fs-18">: ........./........./..............</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="block my-2 fs-18 content-size hodo-table" v-html="form.content"></div>

              <div class="block mt-12">
                <div class="col-6 text-center"></div>
                <div class="col-6 text-center">
                  <div class="font-bold fs-20">{{ $t("lbl_responsible_specialist") }}</div>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <div class="fs-18 font-bold uppercase">{{ form.mainDoctor }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- DOCUMENT PRINT -->
    </b-modal>
  </div>
</template>

<script>
import { TiptapEditor } from "@/components";
import appUtils from "@/utils/appUtils";
import { templateHTMLPrint, base64 } from "@/utils/printUtils";
import ToastificationContent from "@/@core/components/toastification/ToastificationContent.vue";
import { ORDER_FORM_DRAFT } from "@/utils/constant";

const CONTENT = `<div dir="ltr" align="left"></div><div dir="ltr" align="left"> <table> <colgroup> <col width="84"/> <col width="510"/> <col width="102"/> </colgroup> <tbody> <tr> <td> <p dir="ltr"> KẾT QUẢ </p> </td> <td colspan="2"> <p dir="ltr"> Kết quả này chỉ có ý nghĩa trên mẫu nghiệm phẩm nhận được </p> </td> </tr> <tr> <td> <p dir="ltr"> <strong>GENE</strong> </p> </td> <td> <p dir="ltr"> Thể đột biến | Thay đổi trình tự </p> </td> <td> <p dir="ltr"> Tỷ lệ (%) </p> </td> </tr> <tr> <td rowspan="2"> <p dir="ltr"> <strong>EGFR</strong> </p> </td> <td> <p dir="ltr"> EGFR_Del19_chr7 5517477G TTAAGAGAAGCAACATC T </p> </td> <td> <p dir="ltr"> </p> </td> </tr> <tr> <td> <p dir="ltr"> EGFR_G7245_NM_OCG225.5cc.217DG>A</p> </td> <td> <p dir="ltr"> </p> </td> </tr> <tr> <td> <p dir="ltr"> <strong>ALK</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td> </td> </tr> <tr> <td> <p dir="ltr"> <strong>RO51</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td></td> </tr> <tr> <td> <p dir="ltr"> <strong>KRAS</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td></td> </tr> <tr> <td> <p dir="ltr"> <strong>BRAF</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td> </td> </tr> <tr> <td> <p dir="ltr"> <strong>NTRX</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td> </td> </tr> <tr> <td> <p dir="ltr"> <strong>MET</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td> </td> </tr> <tr> <td> <p dir="ltr"> <strong>NRAS</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td> </td> </tr> <tr> <td> <p dir="ltr"> <strong>PIK3CA</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td> </td> </tr> <tr> <td> <p dir="ltr"> <strong>HER2</strong> </p> </td> <td> <p dir="ltr"> Chưa phát hiện đột biến có ý nghĩa lâm sang </p> </td> <td> </td> </tr> <tr> <td> <p dir="ltr"> KẾT LUẬN </p> </td> <td colspan="2"> <p dir="ltr"> Phát hiện đột biến gen 19 trên gen EGFR </p> </td> </tr> <tr> <td colspan="3"> <p dir="ltr"> </p> </td> </tr> <tr> <td colspan="3"> <p dir="ltr"> LƯU Ý </p></br> </td> </tr> </tbody> </table></div>`;

const DEFAULT_FORM = {
  name: "",
  labCode: "",
  birthYear: "",
  gender: null,
  diagnosis: "",
  sample: "",
  doctorAppointed: "",
  date: null,
  address: "",
  resultDate: null,
  content: CONTENT,
  mainDoctor: ""
};

export default {
  name: "ModalCreateResultForm",
  components: { TiptapEditor },
  props: {
    orderItem: Object,
    orderDetail: Object
  },
  data() {
    return {
      form: { ...DEFAULT_FORM },
      loading: false
    };
  },
  watch: {
    orderDetail: {
      deep: true,
      handler(data) {
        this.handleMapData(data);
      }
    }
  },
  mounted() {
    this.handleMapData(this.orderDetail);
  },
  computed: {
    logo() {
      const userData = appUtils.getLocalUser();

      return {
        logoRight:
          userData?.processorsInfo?.logo || userData?.supplierInfo?.logo,
        logoLeft:
          userData?.processorsInfo?.logo_sub || userData?.supplierInfo?.logo_sub
      };
    },
    userAddress() {
      const userData = appUtils.getLocalUser();
      return (
        userData?.processorsInfo?.address || userData?.supplierInfo?.address
      );
    },
    companyName() {
      const userData = appUtils.getLocalUser();
      return userData?.processorsInfo?.name || userData?.supplierInfo?.name;
    }
  },
  methods: {
    handleMapData(data, formData) {
      if (formData) {
        this.form = { ...formData };
      }

      const patientInfo =
        data?.order_contact?.find(item => item?.type === 2) ||
        data?.order_contact?.find(item => item?.type === 1);

      this.form.name = formData?.name || patientInfo?.name;
    },
    async handleSubmitResultForm(bvModalEvent) {
      this.loading = true;

      bvModalEvent.preventDefault();

      try {
        const self = this;
        const bodyHTML = self.$refs.documentPrint.innerHTML;
        const tempHTML = templateHTMLPrint({ bodyHTML });
        const base64Data = base64().decode(tempHTML);
        await this.savePdfToS3(base64Data);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async savePdfToS3(base64) {
      if (!this.orderItem?.data?.id) return;
      try {
        const payload = {
          content: base64,
          fileName: `${appUtils.slugifyStr(
            `Supplier_Result_${this.orderItem?.data?.product_name?.trim()}`,
            "_"
          )}_`,
          path: "supplier",
          type: "test",
          type_id: "test",
          uuid: "test"
        };

        const res = await this.$rf
          .getRequest("CommonRequest")
          .printDocument(payload);

        const url = res.data?.documentLink;

        await this.$rf
          .getRequest("CommonRequest")
          .updateOrderItemResultUrl(this.orderItem?.data?.id, {
            document_link: [{ url, updated_at: Math.floor(Date.now() / 1000) }]
          });
        this.loading = false;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("lbl_the_result_form_has_been_generated"),
            icon: "CheckIcon",
            variant: "success"
          }
        });
        // await this.handleSaveDraft();
        this.$bvModal.hide("ModalCreateResultForm");

        this.$emit("onSuccess");

        // this.showModal = false;

        // window.open(res.data?.documentLink, "_blank", "noreferrer");
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t("lbl_failed_to_generate_the_result_form"),
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      }
    },
    async handleSaveDraft() {
      if (!this.orderItem?.data?.id || this.loading) return;

      const productId = Number(this.orderItem.data.id);

      const params = {
        form_type: ORDER_FORM_DRAFT.RESULT_FORM,
        edited_at: Date.now(),
        order_item_id: productId,
        content: JSON.stringify(this.form)
      };

      try {
        await this.$rf.getRequest("CommonRequest").postDraftOrderForm(params);
      } catch (error) {
        console.log(error);
      } finally {
        this.form = { ...DEFAULT_FORM };
        this.handleMapData(this.orderDetail);
        this.$emit("refresh");
      }
    },
    async handleGetDraft() {
      if (!this.orderItem?.data?.id) return;
      const productId = Number(this.orderItem.data.id);

      try {
        const params = {
          order_item_id: productId,
          order_form_type: ORDER_FORM_DRAFT.RESULT_FORM
        };

        const response = await this.$rf
          .getRequest("CommonRequest")
          .getDraftOrderForm(params);

        const responseData = response.data?.data;
        if (!responseData?.content) return;
        const formData = JSON.parse(responseData.content);
        this.handleMapData(this.orderDetail, formData);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cs-container * {
  color: black;
}

.row-item {
  display: flex;
  flex-direction: column;
}

.cs-flex-1 {
  flex: 1;
  min-height: 40px;
}

.cs-header {
  font-size: 30px;
  text-align: center;
  font-weight: 700;
  display: block;
  margin-bottom: 40px;
  margin-top: 20px;
}

.cs-title {
  font-size: 22px;
}

.hodo-table ::v-deep {
  figure {
    margin: 0 0 1rem !important;
  }
  table {
    border-collapse: collapse !important;
    width: 100% !important;
    border: 1px solid #363636 !important;
    margin-top: 1rem !important;
  }
  table thead th {
    text-transform: uppercase !important;
  }
  table th,
  table td {
    padding: 8px !important;
    border: 1px solid #474747 !important;
  }
}
</style>
